import { Tafgeet } from 'tafgeet-arabic';
import { isAr } from './calc-common.js';

export const CURRENCIES = [
  // 1. Arab League Currencies (22 Countries)
  { code: 'SAR', nameAr: 'ريال سعودي', nameEn: 'Saudi Riyal', flag: '🇸🇦', symbol: 'ر.س', tafgeet: 'SAR' },
  { code: 'EGP', nameAr: 'جنيه مصري', nameEn: 'Egyptian Pound', flag: '🇪🇬', symbol: 'ج.م', tafgeet: 'EGP' },
  { code: 'AED', nameAr: 'درهم إماراتي', nameEn: 'UAE Dirham', flag: '🇦🇪', symbol: 'د.إ', tafgeet: 'AED' },
  { code: 'KWD', nameAr: 'دينار كويتي', nameEn: 'Kuwaiti Dinar', flag: '🇰🇼', symbol: 'د.ك', tafgeet: 'KWD' },
  { code: 'QAR', nameAr: 'ريال قطري', nameEn: 'Qatari Riyal', flag: '🇶🇦', symbol: 'ر.ق', tafgeet: 'QAR' },
  { code: 'BHD', nameAr: 'دينار بحريني', nameEn: 'Bahraini Dinar', flag: '🇧🇭', symbol: 'د.ب', tafgeet: 'BHD' },
  { code: 'OMR', nameAr: 'ريال عُماني', nameEn: 'Omani Rial', flag: '🇴🇲', symbol: 'ر.ع', tafgeet: 'OMR' },
  { code: 'JOD', nameAr: 'دينار أردني', nameEn: 'Jordanian Dinar', flag: '🇯🇴', symbol: 'د.أ', tafgeet: 'JOD' },
  { code: 'IQD', nameAr: 'دينار عراقي', nameEn: 'Iraqi Dinar', flag: '🇮🇶', symbol: 'د.ع', tafgeet: 'IQD' },
  { code: 'MAD', nameAr: 'درهم مغربي', nameEn: 'Moroccan Dirham', flag: '🇲🇦', symbol: 'د.م', tafgeet: 'MAD' },
  { code: 'DZD', nameAr: 'دينار جزائري', nameEn: 'Algerian Dinar', flag: '🇩🇿', symbol: 'د.ج', tafgeet: 'DZD' },
  { code: 'TND', nameAr: 'دينار تونسي', nameEn: 'Tunisian Dinar', flag: '🇹🇳', symbol: 'د.ت', tafgeet: 'TND' },
  { code: 'LYD', nameAr: 'دينار ليبي', nameEn: 'Libyan Dinar', flag: '🇱🇾', symbol: 'د.ل', tafgeet: 'LYD' },
  { code: 'SDG', nameAr: 'جنيه سوداني', nameEn: 'Sudanese Pound', flag: '🇸🇩', symbol: 'ج.س', tafgeet: 'SDG' },
  { code: 'LBP', nameAr: 'ليرة لبنانية', nameEn: 'Lebanese Pound', flag: '🇱🇧', symbol: 'ل.ل', tafgeet: 'LBP' },
  { code: 'SYP', nameAr: 'ليرة سورية', nameEn: 'Syrian Pound', flag: '🇸🇾', symbol: 'ل.س', tafgeet: 'SYP' },
  { code: 'YER', nameAr: 'ريال يمني', nameEn: 'Yemeni Rial', flag: '🇾🇪', symbol: 'ر.ي', tafgeet: 'YER' },
  { code: 'MRU', nameAr: 'أوقية موريتانية', nameEn: 'Mauritanian Ouguiya', flag: '🇲🇷', symbol: 'أ.م' },
  { code: 'SOS', nameAr: 'شلن صومالي', nameEn: 'Somali Shilling', flag: '🇸🇴', symbol: 'ش.ص' },
  { code: 'DJF', nameAr: 'فرنك جيبوتي', nameEn: 'Djiboutian Franc', flag: '🇩🇯', symbol: 'ف.ج' },
  { code: 'KMF', nameAr: 'فرنك قمري', nameEn: 'Comorian Franc', flag: '🇰🇲', symbol: 'ف.ق' },
  { code: 'ILS', nameAr: 'شيكل', nameEn: 'Shekel', flag: '🇵🇸', symbol: '₪' },

  // 2. Major Global Currencies
  { code: 'USD', nameAr: 'دولار أمريكي', nameEn: 'US Dollar', flag: '🇺🇸', symbol: '$', tafgeet: 'USD' },
  { code: 'EUR', nameAr: 'يورو', nameEn: 'Euro', flag: '🇪🇺', symbol: '€', tafgeet: 'EUR' },
  { code: 'GBP', nameAr: 'جنيه إسترليني', nameEn: 'British Pound', flag: '🇬🇧', symbol: '£', tafgeet: 'GBP' },
  { code: 'TRY', nameAr: 'ليرة تركية', nameEn: 'Turkish Lira', flag: '🇹🇷', symbol: '₺', tafgeet: 'TRY' },
  { code: 'CAD', nameAr: 'دولار كندي', nameEn: 'Canadian Dollar', flag: '🇨🇦', symbol: 'CA$', tafgeet: 'CAD' },
  { code: 'AUD', nameAr: 'دولار أسترالي', nameEn: 'Australian Dollar', flag: '🇦🇺', symbol: 'AU$', tafgeet: 'AUD' },
  { code: 'CHF', nameAr: 'فرنك سويسري', nameEn: 'Swiss Franc', flag: '🇨🇭', symbol: 'CHF', tafgeet: 'CHF' },
  { code: 'JPY', nameAr: 'ين ياباني', nameEn: 'Japanese Yen', flag: '🇯🇵', symbol: '¥' },
  { code: 'CNY', nameAr: 'يوان صيني', nameEn: 'Chinese Yuan', flag: '🇨🇳', symbol: '¥' },
  { code: 'INR', nameAr: 'روبية هندية', nameEn: 'Indian Rupee', flag: '🇮🇳', symbol: '₹' },
  { code: 'PKR', nameAr: 'روبية باكستانية', nameEn: 'Pakistani Rupee', flag: '🇵🇰', symbol: '₨' },
  { code: 'BDT', nameAr: 'تاكا بنغلاديشية', nameEn: 'Bangladeshi Taka', flag: '🇧🇩', symbol: '৳' },
  { code: 'IDR', nameAr: 'روبية إندونيسية', nameEn: 'Indonesian Rupiah', flag: '🇮🇩', symbol: 'Rp' },
  { code: 'MYR', nameAr: 'رينغيت ماليزي', nameEn: 'Malaysian Ringgit', flag: '🇲🇾', symbol: 'RM' },
  { code: 'PHP', nameAr: 'بيزو فلبيني', nameEn: 'Philippine Peso', flag: '🇵🇭', symbol: '₱' },
  { code: 'SGD', nameAr: 'دولار سنغافوري', nameEn: 'Singapore Dollar', flag: '🇸🇬', symbol: 'S$' },
  { code: 'HKD', nameAr: 'دولار هونغ كونغ', nameEn: 'Hong Kong Dollar', flag: '🇭🇰', symbol: 'HK$' },
  { code: 'KRW', nameAr: 'وون كوري جنوبي', nameEn: 'South Korean Won', flag: '🇰🇷', symbol: '₩' },
  { code: 'BRL', nameAr: 'ريال برازيلي', nameEn: 'Brazilian Real', flag: '🇧🇷', symbol: 'R$' },
  { code: 'MXN', nameAr: 'بيزو مكسيكي', nameEn: 'Mexican Peso', flag: '🇲🇽', symbol: 'Mex$' },
  { code: 'ARS', nameAr: 'بيزو أرجنتيني', nameEn: 'Argentine Peso', flag: '🇦🇷', symbol: '$' },
  { code: 'ZAR', nameAr: 'راند جنوب إفريقي', nameEn: 'South African Rand', flag: '🇿🇦', symbol: 'R' },
  { code: 'NGN', nameAr: 'نايرا نيجيرية', nameEn: 'Nigerian Naira', flag: '🇳🇬', symbol: '₦' },
  { code: 'KES', nameAr: 'شلن كيني', nameEn: 'Kenyan Shilling', flag: '🇰🇪', symbol: 'KSh' },
  { code: 'GHS', nameAr: 'سيدي غاني', nameEn: 'Ghanaian Cedi', flag: '🇬🇭', symbol: 'GH₵' },
  { code: 'RUB', nameAr: 'روبل روسي', nameEn: 'Russian Ruble', flag: '🇷🇺', symbol: '₽' },
  { code: 'SEK', nameAr: 'كرونة سويدية', nameEn: 'Swedish Krona', flag: '🇸🇪', symbol: 'kr' },
  { code: 'NOK', nameAr: 'كرونة نرويجية', nameEn: 'Norwegian Krone', flag: '🇳🇴', symbol: 'kr' },
  { code: 'DKK', nameAr: 'كرونة دنماركية', nameEn: 'Danish Krone', flag: '🇩🇰', symbol: 'kr' },
  { code: 'PLN', nameAr: 'زلوتي بولندي', nameEn: 'Polish Zloty', flag: '🇵🇱', symbol: 'zł' },
  { code: 'CZK', nameAr: 'كرونة تشيكية', nameEn: 'Czech Koruna', flag: '🇨🇿', symbol: 'Kč' },
  { code: 'HUF', nameAr: 'فورنت مجري', nameEn: 'Hungarian Forint', flag: '🇭🇺', symbol: 'Ft' },
  { code: 'RON', nameAr: 'ليو روماني', nameEn: 'Romanian Leu', flag: '🇷🇴', symbol: 'lei' },
  { code: 'THB', nameAr: 'بات تايلاندي', nameEn: 'Thai Baht', flag: '🇹🇭', symbol: '฿' },
  { code: 'VND', nameAr: 'دونغ فيتنامي', nameEn: 'Vietnamese Dong', flag: '🇻🇳', symbol: '₫' },
  { code: 'NZD', nameAr: 'دولار نيوزيلندي', nameEn: 'New Zealand Dollar', flag: '🇳🇿', symbol: 'NZ$' },
  { code: 'CLP', nameAr: 'بيزو تشيلي', nameEn: 'Chilean Peso', flag: '🇨🇱', symbol: '$' },
  { code: 'COP', nameAr: 'بيزو كولومبي', nameEn: 'Colombian Peso', flag: '🇨🇴', symbol: '$' },
  { code: 'PEN', nameAr: 'سول بيروفي', nameEn: 'Peruvian Sol', flag: '🇵🇪', symbol: 'S/' },
  { code: 'TWD', nameAr: 'دولار تايواني', nameEn: 'New Taiwan Dollar', flag: '🇹🇼', symbol: 'NT$' },
  { code: 'AZN', nameAr: 'مانات أذربيجاني', nameEn: 'Azerbaijani Manat', flag: '🇦🇿', symbol: '₼' },
  { code: 'GEL', nameAr: 'لاري جورجي', nameEn: 'Georgian Lari', flag: '🇬🇪', symbol: '₾' },
  { code: 'KZT', nameAr: 'تنغي كازاخستاني', nameEn: 'Kazakhstani Tenge', flag: '🇰🇿', symbol: '₸' },
  { code: 'UZS', nameAr: 'سوم أوزبكستاني', nameEn: 'Uzbekistani Som', flag: '🇺🇿', symbol: 'soʻm' }
];

/**
 * Format invoice currency with symbol/code
 */
export function formatInvoiceAmount(val, currencyCode) {
  if (val === null || val === undefined || isNaN(val)) return '0.00';
  const num = Number(val);
  const formatted = num.toLocaleString(isAr ? 'ar-EG' : 'en-US', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  });
  const found = CURRENCIES.find((c) => c.code === currencyCode);
  const symbol = found?.symbol || currencyCode;
  return `${formatted} ${symbol}`;
}

/**
 * Generate Tafgeet (amount in words) with universal currency support
 */
export function getInvoiceTafgeet(amount, currencyCode) {
  const num = parseFloat(Number(amount).toFixed(2));
  if (isNaN(num) || num <= 0) return '';

  const found = CURRENCIES.find((c) => c.code === currencyCode);
  const currencyNameAr = found?.nameAr || currencyCode;
  const currencyNameEn = found?.nameEn || currencyCode;

  if (isAr) {
    if (found?.tafgeet) {
      try {
        const taf = new Tafgeet(num, found.tafgeet);
        return `فقط وقدره: ${taf.parse()}`;
      } catch {
        // Fallback to read()
      }
    }
    try {
      const intPart = Math.floor(num);
      const fracPart = Math.round((num - intPart) * 100);
      const taf = new Tafgeet(1, 'SAR');
      const intWords = taf.read(intPart);
      let res = `فقط وقدره: ${intWords} ${currencyNameAr}`;
      if (fracPart > 0) {
        const fracWords = taf.read(fracPart);
        res += ` و${fracWords} سنت`;
      }
      res += ' لا غير';
      return res;
    } catch {
      return `فقط وقدره: ${num} ${currencyNameAr}`;
    }
  }

  // English format
  return `Amount in words: ${formatInvoiceAmount(num, currencyCode)}`;
}

/**
 * Modern Searchable Currency Selector
 */
export function initSearchableCurrency({
  triggerBtn,
  popoverEl,
  searchInput,
  listEl,
  hiddenInput,
  onSelect
}) {
  if (!triggerBtn || !popoverEl || !listEl || !hiddenInput) return;

  function updateTriggerDisplay(code) {
    const item = CURRENCIES.find((c) => c.code === code) || CURRENCIES[0];
    const name = isAr ? item.nameAr : item.nameEn;
    triggerBtn.innerHTML = `
      <span class="inv-curr-flag">${item.flag}</span>
      <span class="inv-curr-code">${item.code}</span>
      <span class="inv-curr-name">${name} (${item.symbol})</span>
      <span class="inv-curr-arrow">▾</span>
    `;
    hiddenInput.value = item.code;
  }

  function renderList(query = '') {
    const q = query.trim().toLowerCase();
    const filtered = CURRENCIES.filter((c) => {
      if (!q) return true;
      return (
        c.code.toLowerCase().includes(q) ||
        c.nameAr.toLowerCase().includes(q) ||
        c.nameEn.toLowerCase().includes(q) ||
        c.symbol.toLowerCase().includes(q)
      );
    });

    if (filtered.length === 0) {
      listEl.innerHTML = `<div class="inv-curr-empty">${isAr ? 'لا توجد عملات مطابقة' : 'No matching currencies'}</div>`;
      return;
    }

    listEl.innerHTML = filtered
      .map((c) => {
        const isSelected = c.code === hiddenInput.value;
        const name = isAr ? c.nameAr : c.nameEn;
        return `
          <button type="button" class="inv-curr-option ${isSelected ? 'is-selected' : ''}" data-code="${c.code}">
            <span class="inv-curr-flag">${c.flag}</span>
            <div class="inv-curr-meta">
              <strong>${c.code} · ${c.symbol}</strong>
              <small>${name}</small>
            </div>
            ${isSelected ? '<span class="inv-curr-check">✓</span>' : ''}
          </button>
        `;
      })
      .join('');

    listEl.querySelectorAll('.inv-curr-option').forEach((opt) => {
      opt.addEventListener('click', () => {
        const code = opt.dataset.code;
        hiddenInput.value = code;
        updateTriggerDisplay(code);
        closePopover();
        if (typeof onSelect === 'function') onSelect(code);
      });
    });
  }

  function openPopover() {
    popoverEl.hidden = false;
    triggerBtn.setAttribute('aria-expanded', 'true');
    if (searchInput) {
      searchInput.value = '';
      searchInput.focus();
    }
    renderList('');
  }

  function closePopover() {
    popoverEl.hidden = true;
    triggerBtn.setAttribute('aria-expanded', 'false');
  }

  triggerBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    if (popoverEl.hidden) {
      openPopover();
    } else {
      closePopover();
    }
  });

  searchInput?.addEventListener('input', (e) => {
    renderList(e.target.value);
  });

  document.addEventListener('click', (e) => {
    if (!popoverEl.hidden && !popoverEl.contains(e.target) && !triggerBtn.contains(e.target)) {
      closePopover();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !popoverEl.hidden) {
      closePopover();
      triggerBtn.focus();
    }
  });

  // Initial set
  updateTriggerDisplay(hiddenInput.value || 'SAR');
}
